import type { ReactNode } from "react";
import { cn } from "./cn.js";

/** Backdrop + centered card scaffold shared by the panel modals. */
export function ModalShell({
  onClose,
  className,
  children,
}: {
  onClose: () => void;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className={cn("w-full max-w-lg rounded-lg border border-border bg-surface p-4 shadow-xl", className)}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
